/*
 * Zweites Produktbild erst beim ersten Hover einfügen (nur Desktop mit Maus).
 * Das Bild liegt bis dahin in einem <template> und zählt nicht zum DOM.
 */
(() => {
  if (window.__productCardHover) return;
  window.__productCardHover = true;

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.addEventListener('mouseover', (event) => {
    const link = event.target.closest('[data-hover-image]');
    if (!link) return;
    const template = link.querySelector('template[data-hover-image-template]');
    if (!template) return;
    link.appendChild(template.content.cloneNode(true));
    template.remove();
    link.classList.add('has-hover-image');
  });
})();